'use strict';
var $export = require('./$.export')
  , $pad    = require('./$.string-pad');

$export($export.P, 'String', {
  padRight: function padRight(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/babel-core/~/core-js/modules/es7.string.pad-right.js
 ** module id = 525
 ** module chunks = 0
 **/